// extracted by mini-css-extract-plugin
export var container = "contact-module--container--3AFrV";
export var firstImage = "contact-module--firstImage--3Xbxp";
export var grid = "contact-module--grid--1IU8Q";
export var grid2 = "contact-module--grid2--2A4r1";
export var label = "contact-module--label--1SAzV";
export var input = "contact-module--input--3IO8X";
export var textarea = "contact-module--textarea--2EVZ8";
export var sidebar = "contact-module--sidebar--2oE7v";